import { render, staticRenderFns } from "./AddStaffItem.vue?vue&type=template&id=223439dd&scoped=true"
import script from "./AddStaffItem.vue?vue&type=script&lang=js"
export * from "./AddStaffItem.vue?vue&type=script&lang=js"
import style0 from "./AddStaffItem.vue?vue&type=style&index=0&id=223439dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223439dd",
  null
  
)

export default component.exports